<template>
  <div class="d-flex justify-content-center mb-8 otp-container">
    <input
      v-for="(s, i) in tamanho"
      :key="i"
      class="form-control form-control-solid h-auto px-2 py-3 rounded-lg font-weight-bolder text-center bg-gray-300 wl-input"
      type="text"
      inputmode="numeric"
      :name="`codigo${i}`"
      v-model="codigo[i]"
      autocomplete="one-time-code"
      ref="codigos"
      :autofocus="i === 0"
      maxlength="1"
      @input="handleInput($event, i)"
      @keydown="handleKeyDown($event, i)"
      @keyup.enter="$emit('enter', i)"
    />
  </div>
</template>

<script>
// SEU SCRIPT (NENHUMA MUDANÇA NECESSÁRIA AQUI)
export default {
  name: "fa-input",
  data: () => ({ codigo: [], tamanho: 6 }),
  mounted() {
    const inputs = this.$refs.codigos;
    inputs.forEach((input) => {
      input.addEventListener("paste", (event) => {
        event.preventDefault();
        const paste = (event.clipboardData || window.clipboardData)
          .getData("text")
          .trim();
        if (new RegExp(`^\\d{${this.tamanho}}$`).test(paste)) {
          this.codigo = paste.split("");
          this.$refs.codigos[this.tamanho - 1].focus();
          this.$emit("codigo:atualizado", paste);
          this.$emit("enter");
        }
      });
    });
  },
  methods: {
    handleInput(event, index) {
      const value = event.target.value;
      if (value && new RegExp(/^\d+$/).test(value)) {
        this.$set(this.codigo, index, value);
        if (index < this.tamanho - 1) this.$refs.codigos[index + 1].focus();
        this.$emit("codigo:atualizado", this.codigo.join(""));
        if (this.codigo.join("").length === this.tamanho) this.$emit("enter");
      }
    },
    handleKeyDown(event, index) {
      if (event.key === "Backspace" && index > 0 && !this.codigo[index]) {
        this.$refs.codigos[index - 1].focus();
      }
    }
  }
};
</script>

<style scoped>
.otp-container {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.otp-container .wl-input {
  flex: 1;
  min-width: 0;
  width: auto;

  /* REGRAS DE TAMANHO MÁXIMO */
  max-width: 60px;
  font-size: 3rem !important;

  aspect-ratio: 1 / 1;
  padding: 0.5rem;
}

/* RESPONSIVO PARA CELULAR */
@media (max-width: 576px) {
  .otp-container {
    gap: 0.25rem;
  }
  .otp-container .wl-input {
    font-size: 1.5rem !important;
  }
}

/* ESTILOS BASE */
.wl-input {
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  text-align: center;
  background-color: #fff !important;
  height: auto !important;
}

.wl-input:hover {
  border: 1px solid #b2b2b2;
}

.wl-input:not(:active) {
  border: 1px solid #b2b2b2 !important;
}
</style>
